import { SKIP_GROUP_IDENTIFIER } from '@modules/showroom/productCollection/enhancedView/constants/cnf-product-constants'
import cloneDeep from 'lodash/cloneDeep'
import { map } from 'lodash'
import { SORT_ORDERS } from '@components/UI-Components/EnhancedView/Sort/sort_constants'
import { METRIC_ATTRIBUTES } from '../constants/uiConstants'
import { nav } from '@stores'
import { View } from '../constants/views'
import { transformValueAsPerAttributeType } from '@utils/get-product-attribute-value'

/**
 * This method skips/removes the child item which meant to be skipped from grouping
 *
 * @param data
 */
export const removeSkippedGroups = data => {
  if (data?.children?.length) {
    data.children.forEach(currentChild => {
      if (currentChild?.children?.length) {
        const tempSkipItem = currentChild.children[0]
        if (tempSkipItem?.name === SKIP_GROUP_IDENTIFIER) {
          if (tempSkipItem?.children?.length) {
            currentChild.childrenAttributeId = tempSkipItem.childrenAttributeId
            currentChild.totalProducts = tempSkipItem.totalProducts
            currentChild.children = tempSkipItem.children
          } else {
            delete currentChild.children
            delete currentChild.childrenAttributeId
          }
        }
        removeSkippedGroups(currentChild)
      }
    })
  }
}

/**
 * This method assigns the type of attributeId to current group name object
 *
 * @param data
 */
export const formatProductGroupsData = (data, defaulName) => {
  if (data?.children?.length) {
    data.children.forEach(currentChild => {
      currentChild.attributeId = data.childrenAttributeId
      addMetricAttributesToGroupsData(currentChild)
      if (!currentChild.name) {
        currentChild.name = defaulName
      }
      if (currentChild.children) {
        formatProductGroupsData(currentChild, defaulName)
      }
    })
  }
}

export const addMetricAttributesToGroupsData = data => {
  if (data) {
    const temp = {}
    METRIC_ATTRIBUTES.forEach(metric => {
      if (data.hasOwnProperty(metric)) {
        temp[metric] = data[metric]
      }
    })
    if (Object.keys(temp).length) {
      data.metricAttributesData = temp
    }
  }
}

/**
 * This function adds the array of group names which are parent of that product as
 * per the applied grouping structure
 * @param data
 * @param mapping
 */
export const addHierarchyNamesToProductsData = (data, mapping) => {
  const {
    queryParams: { view }
  } = nav
  if (data?.length) {
    const newData = cloneDeep(data)
    newData.forEach(item => {
      item.hierarchyItems = Object.values(mapping).map(el => el[0])
      if (view === View.List) {
        item.hierarchyItemsAtributeIds = Object.keys(mapping)
      }
    })
    return newData
  }
  return data
}

/**
 * This function returns mapping of grouping name and its attribute id
 * per the applied grouping structure
 * @param grouping
 * @param emptyPlaceholder
 */
export const getCurrentGroupMapping = (
  grouping,
  emptyPlaceholder,
  findSpecificAttribute
) => {
  let mapping = {}
  grouping.forEach(item => {
    const attributeObj = findSpecificAttribute?.(item.attributeId)
    const value = attributeObj
      ? transformValueAsPerAttributeType(attributeObj.esType, item.name)
      : item.name
    mapping[item.attributeId] = [value === emptyPlaceholder ? '' : value]
  })
  return mapping
}

/**
 * This function returns filters attribute ids
 * @param filters
 */
export const mapNewFiltersToIds = filters => {
  return Object.keys(filters).reduce((acc, filterKey) => {
    acc[filterKey] = map(filters[filterKey], 'value')
    return acc
  }, {})
}

/**
 * This function returns applied sort string
 * @param appliedSort
 */
export const parseAppliedSort = appliedSort => {
  let sortData = appliedSort?.id ? appliedSort?.id : ''
  if (sortData) {
    sortData = appliedSort.orderBy === SORT_ORDERS.ASC ? '+' + sortData : '-' + sortData
  }
  return sortData
}

/**
 * This function is to add parent level data in each child of heirarchy
 * @param parent
 */
export const addParentsGroupData = parent => {
  if (parent?.children?.length) {
    parent.children.forEach(currentChild => {
      currentChild.attributeId = parent.childrenAttributeId
      const attributeNames = parent.parentGroupNames || []
      const attributeIds = parent.parentAttributeIds || []
      let tempAttributeName = []
      let tempAttributeId = []
      if (currentChild.attributeId) {
        tempAttributeId = [currentChild.attributeId]
      }
      tempAttributeName = [currentChild.name]
      currentChild.parentGroupNames = attributeNames.concat(tempAttributeName)
      currentChild.parentAttributeIds = attributeIds.concat(tempAttributeId)
      if (currentChild.children) {
        addParentsGroupData(currentChild)
      }
    })
  }
}

/**
 * This method transforms child items
 *
 * @param data
 */
export const formatCustomViewTableData = (parent, defaulName) => {
  if (parent?.children?.length) {
    const iterableChildren = parent?.children || []
    iterableChildren.forEach(currentChild => {
      currentChild.attributeId = parent.childrenAttributeId
      const attributeNames = parent.parentGroupNames || []
      const attributeIds = parent.parentAttributeIds || []
      let tempAttributeName = []
      let tempAttributeId = []
      if (currentChild.attributeId) {
        tempAttributeId = [currentChild.attributeId]
      }
      tempAttributeName = [currentChild.name]
      currentChild.parentGroupNames = attributeNames.concat(tempAttributeName)
      currentChild.parentAttributeIds = attributeIds.concat(tempAttributeId)
      if (!currentChild.name) {
        currentChild.name = defaulName
      }
      if (currentChild.children) {
        formatCustomViewTableData(currentChild, defaulName)
      }
    })
  }
}
